export interface SingleFlightSlot<T> {
  current: Promise<T> | null
}

/** Join concurrent callers to one operation; release the slot on either settlement path. */
export function runSingleFlight<T>(
  slot: SingleFlightSlot<T>,
  operation: () => Promise<T>,
): Promise<T> {
  if (slot.current) return slot.current

  let promise: Promise<T>
  try {
    promise = Promise.resolve(operation())
  } catch (error) {
    promise = Promise.reject(error)
  }
  slot.current = promise
  const clear = () => {
    if (slot.current === promise) slot.current = null
  }
  // Attach both paths directly; using an ignored finally() would create a new
  // rejecting promise and can surface as an unhandled rejection.
  void promise.then(clear, clear)
  return promise
}
